export default [
    {
      path: '/nationalList',
      name: 'nationalList',
      meta: {
          title: '所属国家或地区选择'
      },
      component: () => import('@/views/app/nationalList')
    },
  ]